import { useIntl } from 'react-intl';
import { useCallback } from 'react';

import { PointsStrategy } from '@ocx/graphql';
import { useSnackbar } from '../../../lib/snackbar/snackbar';
import { IneligibilityReason } from '../../../modules/offers/eligibility.types';
import { ineligibilityMessages } from './ineligibility.messages';
import { useConfiguration } from '../../../modules/configuration/useConfiguration';

const findNotEnoughPoints = (reason: IneligibilityReason) => reason.type === 'not_enough_points';
const findPurchasableEligibilityConstraintFailed = (reason: IneligibilityReason) =>
  reason.type === 'purchasable_eligibility_constraint_failed';

export const useShowExplanationSnackbarForIneligibleOffer = () => {
  const intl = useIntl();
  const snackbar = useSnackbar();
  const pointsStrategy = useConfiguration('loyaltyProgram.pointsStrategy');

  return useCallback(
    (reason: IneligibilityReason) => {
      if (findPurchasableEligibilityConstraintFailed(reason)) {
        snackbar.open(
          intl.formatMessage(
            ineligibilityMessages['offer:ineligibility-reason:purchasable-eligibility-constraint-failed'],
          ),
        );
        return;
      }
      if (findNotEnoughPoints(reason) && pointsStrategy === PointsStrategy.Points) {
        snackbar.open(
          intl.formatMessage(
            ineligibilityMessages['offer:points-strategy:points:ineligibility-reason:not-enough-funds'],
          ),
        );
        return;
      }
      if (findNotEnoughPoints(reason) && pointsStrategy === PointsStrategy.Cents) {
        snackbar.open(
          intl.formatMessage(
            ineligibilityMessages['offer:points-strategy:cents:ineligibility-reason:not-enough-funds'],
          ),
        );
        return;
      }
      snackbar.open(intl.formatMessage(ineligibilityMessages['offer:ineligibility-reason:unknown']));
    },
    [intl, pointsStrategy, snackbar],
  );
};
